const translations = {
    required: 'This field is required'
};

export default translations;
